<template>
  <div>
    <v-card
      class="d-flex flex-grow-1"
    >
      <!-- loading spinner -->
      <div
        v-if="loading"
        class="d-flex flex-grow-1 align-center justify-center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
      <!-- information -->
      <div
        v-else
        class="d-flex flex-column flex-grow-1"
      >
        <v-card-title>
          <div>HEQ/USD</div>
          <v-spacer />
          <v-btn
            text
            color="primary"
            :to="{name: 'Token'}"
          >
            Token Details
          </v-btn>
        </v-card-title>
        <div class="d-flex flex-column flex-grow-1">
          <div class="px-2 pb-2">
            <div class="d-flex align-center">
              <div class="text-h4">
                <sup><small>$</small></sup>
                <!-- :value="currentTokenPrice" -->
                <animated-number
                  :value="totalAssetValue / totalCirculation"
                  :format-value="clipNumber"
                  :duration="1200"
                />
              </div>
              <v-spacer />
              <div class="d-flex flex-column text-right">
                <div class="caption">
                  <v-icon
                    v-if="percentage >= 0"
                    color="success"
                  >
                    mdi-trending-up
                  </v-icon>
                  <v-icon
                    v-else
                    color="error"
                  >
                    mdi-trending-down
                  </v-icon>
                  <strong>
                    <animated-number
                      :value="percentage"
                      :format-value="clipNumber"
                      :duration="1200"
                    />%
                  </strong>

                  last 7 days
                </div>
              </div>
            </div>
            <div class="primary--text text--lighten-1 mt-1">
              Total Supply:
              <animated-number
                :value="totalCirculation"
                :format-value="numberWithCommas"
                :duration="1200"
              />
            </div>
            <div class="primary--text text--lighten-1 mt-1">
              Portfolio Value: $<animated-number
                :value="totalAssetValue"
                :format-value="numberWithCommas"
                :duration="1200"
              />
            </div>
          </div>
        </div>
        <apexchart
          type="area"
          height="100"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'
  export default {
    name: 'TokenSummaryCard',
    components: {
      AnimatedNumber,
    },

    provide: {
      heading: { align: 'center' },
    },

    props: {
      totalSavings: Number,
      link: Boolean,
      subtitle: String,
      title: String,
      // value: Boolean,
      features: Array,
      value: {
        type: Number,
        default: 0,
      },
      percentage: {
        type: Number,
        default: 2,
      },
      percentageLabel: {
        type: String,
        default: 'last 7 days',
      },
      series: {
        type: Array,
        default: () => [{
          name: '$',
          data: [1.20, 1.16, 1.02, 1.07, 1.15, 1.19, 1.23],
        }],
      },
      xaxis: {
        type: Object,
        default: () => ({
          type: 'datetime',
          categories: [
            '2021-01-01T00:00:00.000Z',
            '2021-01-02T00:00:00.000Z',
            '2021-01-03T00:00:00.000Z',
            '2021-01-04T00:00:00.000Z',
            '2021-01-05T00:00:00.000Z',
            '2021-01-06T00:00:00.000Z',
            '2021-01-07T00:00:00.000Z',
          ],
        }),
      },
      yaxis: {
        type: Object,
        default: () => ({
          min: 0,
        }),
      },
      label: {
        type: String,
        default: 'Last Price',
      },
      actionLabel: {
        type: String,
        default: 'Trade History',
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      search: null,
      totalCirculation: 1000000000,
      totalAssetValue: 1230000000,
      totalProperties: 1019,
      currentTokenPrice: 1.33,
    }),
    computed: {
      totalCirculationFormatted () {
        return `${this.numberWithCommas(this.totalCirculation)}`
      },

      totalAssetValueFormatted () {
        return `$${this.numberWithCommas(this.totalAssetValue)}`
      },

      totalPropertiesFormatted () {
        return `${this.numberWithCommas(this.totalCirculation)}`
      },

      yaxisUpdated () {
        console.log(this.series.data)
        return {
          min: 0,
          max: 1.61, // update dynamically
        }
      },

      chartOptions () {
        const primaryColor = this.$vuetify.theme.isDark
          ? this.$vuetify.theme.themes.dark.primary
          : this.$vuetify.theme.themes.light.primary
        return {
          chart: {
            height: 90,
            type: 'area',
            sparkline: {
              enabled: true,
            },
            animations: {
              speed: 400,
            },
          },
          colors: [primaryColor],
          fill: {
            type: 'solid',
            // type: 'gradient',
            colors: [primaryColor],
            opacity: 0.15,
          },
          stroke: {
            curve: 'smooth',
            width: 3,
          },
          xaxis: this.xaxis,
          yaxis: this.yaxisUpdated,
          tooltip: {
            followCursor: true,
            theme: 'dark',
            custom: function ({ ctx, series, seriesIndex, dataPointIndex, w }) {
              const seriesName = w.config.series[seriesIndex].name
              return `<div class="rounded-lg pa-1 caption">
              <div>${seriesName}${series[seriesIndex][dataPointIndex]}</div>
            </div>`
            },
          },
          ...this.options,
        }
      },
    },
    watch: {
      search (val) {
        if (!val) {
          return
        }
        this.debounce()
      },
    },
    methods: {
      formatToPrice (value) {
        return value
      },
      numberWithCommas (x) {
        return Number(x).toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      clipNumber (x) {
        return Number(x).toFixed(2)
      },

      debounce (x) {
        clearTimeout(this._timerId)

        this._timerId = setTimeout(() => {
          this.numberWithCommas(x)
        }, 500)
      },
    },
  }
</script>
